import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { sounds } from '../../systems/AudioSystem';
import type { AssetsSchema } from '../../assetManifestTypes';

interface SecretEndingScreenProps {
  onBack: () => void;
}

export const SecretEndingScreen: React.FC<SecretEndingScreenProps> = ({ onBack }) => {
  const typedAssets = ASSETS as AssetsSchema;
  const backgroundAsset = typedAssets.backgrounds?.main_menu_neural_network;

  return (
    <div
      className="menu-screen"
      style={{
        backgroundImage: backgroundAsset ? `url(${backgroundAsset.path})` : undefined,
      }}
    >
      <div className="menu-screen-content">
        <h2>{CONSTANTS.SECRET_ENDING.title}</h2>
        {CONSTANTS.SECRET_ENDING.content.map((text, i) => (
          <p key={i} className="text-center">{text}</p>
        ))}
      </div>
      <button 
        className="menu-button mt-8" 
        onClick={() => {
          sounds.buttonClick();
          onBack();
        }}
        onMouseEnter={() => sounds.menuHover()}
      >
        {CONSTANTS.MAIN_MENU.backButtonText}
      </button>
    </div>
  );
};
